"use client";

import React, { useEffect } from "react";
import { Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";

interface GallerySearchFilterProps {
    onSearchFilter: (search: string) => void;
    resetFilters?: boolean;
}

const GallerySearchFilter = ({ onSearchFilter, resetFilters }: GallerySearchFilterProps) => {
    const formik = useFormik({
        initialValues: {
            search: "",
        },
        validationSchema: Yup.object({
            search: Yup.string().max(200),
        }),
        onSubmit: async (values) => {
            onSearchFilter(values.search);
        },
    });

    useEffect(() => {
        if (resetFilters) {
            formik.resetForm();
            onSearchFilter("");
        }
    }, [resetFilters]);

    return (
        <Form onSubmit={formik.handleSubmit}>
            <Row className="align-items-center">
                <Col xs="auto">
                    <div className="fw-bold">Nr model:</div>
                </Col>

                <Col>
                    <InputGroup>
                        <FormControl
                            value={formik.values.search}
                            onBlur={formik.handleBlur}
                            name="search"
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="ex. 44"
                            style={{ width: "100px" }}
                        />
                        <button type="submit" className="input-group-text">
                            <FaSearch />
                        </button>
                    </InputGroup>
                </Col>
            </Row>
        </Form>
    );
};

export default GallerySearchFilter;
